<style scoped>
.tool-row {
	cursor: pointer;
	transition: background-color 0.15s ease;
}
.tool-row:hover {
	background-color: rgba(13, 110, 253, 0.05);
}
.tool-icon {
	font-size: 1.5rem;
	width: 40px;
	text-align: center;
	color: #0d6efd;
}
</style>

<template>
	<div class="container py-4">
		<div class="d-flex justify-content-between align-items-center mb-4">
			<h1><i class="bi bi-gear-wide-connected me-2"></i>Integrations</h1>
		</div>

		<div class="alert alert-warning">
			<i class="bi bi-exclamation-triangle me-2"></i>
			<strong>Important:</strong> This page allows you to configure integration
			with third-party services. The credentials and tokens stored here provide
			access to external systems and should be protected. Only authorized
			personnel should modify these settings.
		</div>

		<div class="table-responsive">
			<table class="table table-hover align-middle">
				<thead class="table-light">
					<tr>
						<th style="width: 50px"></th>
						<th style="width: 200px">Integration</th>
						<th>Description</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="integration in integrations"
						:key="integration.slug"
						class="tool-row"
						@click="router.push(integration.route)"
					>
						<td>
							<div class="tool-icon">
								<i :class="integration.icon"></i>
							</div>
						</td>
						<td class="fw-semibold">{{ integration.name }}</td>
						<td class="text-muted small">{{ integration.description }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

const router = useRouter();

interface Integration {
	name: string;
	icon: string;
	description: string;
	slug: string;
	route: string;
}

const integrations: Integration[] = [
	{
		name: "Esri's ArcGIS",
		icon: "bi bi-globe2",
		description:
			"Configure your Esri ArcGIS OAuth connection and feature layer mapping.",
		slug: "arcgis",
		route: "/_/configuration/integration/arcgis",
	},
	{
		name: "Frontier Precision's FieldSeeker GIS",
		icon: "bi bi-geo-alt",
		description: "Configure FieldSeeker GIS data synchronization.",
		slug: "fieldseeker",
		route: "/_/configuration/integration/fieldseeker",
	},
	{
		name: "MapVision",
		icon: "bi bi-map",
		description: "Configure the MapVision integration.",
		slug: "mapvision",
		route: "/_/configuration/integration/mapvision",
	},
	{
		name: "VectorSurv",
		icon: "bi bi-bug-fill",
		description:
			"Manage your VectorSurv connection, users and equipment, and its synchronization.",
		slug: "vectorsurv",
		route: "/_/configuration/integration/vectorsurv",
	},
	{
		name: "VeeMac",
		icon: "bi bi-gear-fill",
		description: "Manage your VeeMac credentials and synchronization.",
		slug: "veemac",
		route: "/_/configuration/integration/veemac",
	},
];
</script>
